<template>
    <div style="height: 100%;width: 100%;display: block;overflow:auto; font-size: 12px;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-tabs stretch v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="聊天记录" name="first">
                <el-timeline class="logcard">
                    <van-list v-model="loading" :finished="finished" finished-text="已经全部加载完成" @load="onLoad" style="width: 90%;">
                        <el-timeline-item :timestamp="item.accountdate" placement="top" v-for="(item,key) in beautyVos" :key="key" style="font-size: 12px;margin-left: 10px;">
                            <el-card>
                                <div v-if="item.beautyXfLogs!=null && item.beautyXfLogs.length>0" v-for="(xflog,idx) in item.beautyXfLogs" :key="idx">
                                    <p style="color: red;">门店:{{xflog.storename}}</p>
                                    <p v-if="xflog!=null && xflog.projectname!=null && xflog.projectname!=''"><span style="color:#409eff">消耗项目</span>:{{xflog.projectname}}</p>
                                    <!--<p v-if="xflog!=null && xflog.oparation!=null && xflog.oparation!=''">提升满意度当天做了什么(讲米兰好，效果呈现，不满意处理):{{xflog.oparation}}</p>-->
                                    <p v-if="xflog!=null && xflog.chat!=null && xflog.chat!=''"><span style="color:#409eff">服务日志</span>:{{xflog.chat}}</p>
                                    <!--<p v-if="xflog!=null && xflog.xhtarget!=null && xflog.xhtarget!=''">消耗时铺垫了什么项目(进度):{{xflog.xhtarget}}</p>-->
                                </div>
                                <div v-if="item.hairRepays!=null">
                                    <p v-for="(data,daindex) in item.hairRepays">
                                        <span style="color:#409eff">满意度:</span><el-tag v-if="data.evaluate==1">满意</el-tag>
                                        <el-tag v-else type="danger">不满意</el-tag><br>
                                        <span style="color:#409eff" v-if="data.content">回访结果:</span>{{data.content}}
                                    </p>
                                </div>
                                <div v-if="item.beautySaleLogs!=null && item.beautySaleLogs.length>0" v-for="(salelog,idx) in item.beautySaleLogs" :key="idx">
                                    <p  style="color: red;">门店:{{salelog.storename}}</p>
                                    <p v-if="salelog!=null && salelog.projectname!=null && salelog.projectname!=''">
                                        <span style="color:#409eff">购买项目:</span>{{salelog.projectname}}</p>
                                    <!--<p v-if="salelog!=null && salelog.connected!=null && salelog.connected!=''">销售时沟通细节:{{salelog.connected}}</p>-->
                                    <p v-if="salelog!=null && salelog.programme!=null && salelog.programme!=''">
                                        <span style="color:#409eff">具体方案赠送等:</span>{{salelog.programme}}</p>
                                    <!--<p v-if="salelog!=null && salelog.bedding!=null && salelog.bedding!=''">销售时铺垫了什么项目:{{salelog.bedding}}</p>-->
                                </div>
                            </el-card>
                        </el-timeline-item>
                    </van-list>
                </el-timeline>
            </el-tab-pane>
            <el-tab-pane label="课程注意" name="second">
                <div style="width: 100%;text-align: center;">
                    <el-switch v-model="flag" active-text="剩余疗程" inactive-text="所有疗程"></el-switch>
                </div>
                <el-descriptions direction="vertical" :column="1" border style="margin-top: 10px;">
                    <el-descriptions-item :label="item.projectname" v-for="(item,key) in projectPoints" :key="key">
                        <div>注意事项:{{item.details}}</div>
                        <div>为什么购买:{{item.whybuy}}</div>
                    </el-descriptions-item>
                </el-descriptions>
            </el-tab-pane>
            <el-tab-pane label="服务注意" name="three" style="padding: 10px;">
                <el-form>
                    <el-form-item label="是否接受回访:">
                        <span v-if="beautyServer.returnVisit==1">接受</span>
                        <span v-if="beautyServer.returnVisit==2">不接受</span>
                    </el-form-item>
                    <el-form-item label="当下客户的满意度:">
                        <span v-if="beautyServer.grade==1">一般</span>
                        <span v-if="beautyServer.grade==2">满意</span>
                        <span v-if="beautyServer.grade==3">不满意</span>
                        <span v-if="beautyServer.grade==4">很满意</span>
                    </el-form-item>
                    <el-form-item label="目前有什么不满意的状态:">
                        {{beautyServer.dissatisfied}}
                    </el-form-item>
                    <el-form-item label="喜欢喝什么饮料:">
                        {{beautyServer.drinks}}
                    </el-form-item>
                    <el-form-item label="喜欢吃什么水果:">
                        {{beautyServer.fruits}}
                    </el-form-item>
                    <el-form-item label="喜欢吃什么食物:">
                        {{beautyServer.food}}
                    </el-form-item>
                    <el-form-item label="性格:">
                        {{beautyServer.characters}}
                    </el-form-item>
                    <el-form-item label="喜欢聊天的内容:">
                        {{beautyServer.chat}}
                    </el-form-item>
                    <el-form-item label="不能聊什么:">
                        {{beautyServer.nochat}}
                    </el-form-item>
                    <!--<el-form-item label="与客户的聊天记录">
                        <el-input type="textarea" v-model="beautyServer.chatlog" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>-->
                    <el-form-item label="客户讲的比较重要的话:">
                        {{beautyServer.importantchat}}
                    </el-form-item>
                    <!--<el-form-item label="客情记录送什么时间送过什么">
                        <el-input type="textarea" v-model="beautyServer.givelog" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>-->
                </el-form>
            </el-tab-pane>
          </el-tabs>
        
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName:"first",
                storeid:localStorage.getItem("storeid"),
                memberid:"",
                cardid:"",
                loading:false,
                finished:false,
                beautyVos:[],
                curPage:1,
                projectPoints:[],
                flag:true,
                beautyServer:{},
            }
        },
        created: function () {
            this.cardid=this.$route.query.cardid;
            this.memberid=this.$route.query.memberid;
            this.getBeautySalelogAndXflog();
        },
        methods: {
            getBeautyServerById(){
                this.$post("beautymanager/getBeautyServerById",{storeid:this.storeid,memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        this.beautyServer=res.object;
                        if(this.beautyServer==null){
                            this.beautyServer={};
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardCourseByProjectPoints(){
                let type=1;
                if(this.flag==false){
                    type=2;
                }
                this.$post("hairmanager/getHairCardCourseByProjectPoints",{storeid:this.storeid,cardid:this.cardid,type:type}).then(res=>{
                    if(res.sucess){
                        this.projectPoints=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            handleClick(){
                if(this.activeName=="second"){
                    this.getCardCourseByProjectPoints();
                }
                else if(this.activeName=="three"){
                    this.getBeautyServerById();
                }
            },
            onLoad(){
                this.curPage++;
                this.getBeautySalelogAndXflog();
            },
            getBeautySalelogAndXflog(){
                this.loading=true;
                this.$post("hairmanager/getHairSalelogAndXflog",{memberid:this.memberid,curPage:this.curPage}).then(res=>{
                    this.loading=false;
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.beautyVos.push(val);
                            }
                        }
                        else{
                            this.finished=true;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>

<style style lang="scss" rel="stylesheet/scss">
    .logcard .el-card__body{
        padding: 0px 20px;
    }
</style>


// WEBPACK FOOTER //
// src/page/manager/hairlog.vue